import { size as o } from "./size.mjs";
import { variant as r } from "./variant.mjs";
import { weight as t } from "./weight.mjs";
const e = {
  variant: r,
  size: o,
  weight: t
};
export {
  e as typographyRecipe
};
